import { createSimpleElement } from "../tag/createSimpleElement";

export const RadioIcon = createSimpleElement("span", "radio-icon");
